export const CATEGORY_ICON_SELECT_CONFIG = [
  { displayKey: "Accounting01", searchTerms: ["accounting", "ledger", "tax"] },
  {
    displayKey: "Announcement04",
    searchTerms: ["announcement", "megaphone", "sales", "marketing", "pr"],
  },
  { displayKey: "Archive", searchTerms: ["archive", "storage", "records", "files", "box"] },
  { displayKey: "Award03", searchTerms: ["award", "trophy", "professional fees", "ribbon"] },
  {
    displayKey: "BagDollar01",
    searchTerms: ["bag", "dollar", "revenue", "income", "cogs", "cost of revenue"],
  },
  { displayKey: "Bank", searchTerms: ["bank", "checking", "savings", "accounts", "treasury"] },
  { displayKey: "BankCheck", searchTerms: ["bank", "check", "payments", "transactions"] },
  {
    displayKey: "BankDollar",
    searchTerms: ["bank", "dollar", "fees", "checking", "savings", "accounts", "treasury"],
  },
  { displayKey: "BankNote03", searchTerms: ["bank", "note", "commissions", "dollar bill"] },
  { displayKey: "BankNoteScissors01", searchTerms: ["bank", "note", "scissors", "dollar bill"] },
  {
    displayKey: "Briefcase02",
    searchTerms: ["briefcase", "recruiting", "vacation", "pto", "hiring"],
  },
  { displayKey: "Brush01", searchTerms: ["brush", "paint", "art", "creative", "design"] },
  { displayKey: "Building07", searchTerms: ["building", "office", "facilities", "rent", "lease"] },
  {
    displayKey: "BuildingArrowDown01",
    searchTerms: ["building", "office", "arrow", "down", "amortization"],
  },
  {
    displayKey: "BuildingStar01",
    searchTerms: ["building", "star", "leasehold improvements", "office"],
  },
  { displayKey: "Bus", searchTerms: ["bus", "transportation", "ground", "travel"] },
  {
    displayKey: "Calculator",
    searchTerms: ["calculator", "math", "accounting", "finance", "plus", "minus"],
  },
  { displayKey: "Calendar", searchTerms: ["calendar", "date", "time", "schedule", "event"] },
  {
    displayKey: "CalendarDollar01",
    searchTerms: ["calendar", "dollar", "prepaid expenses", "accrued expenses", "deferred"],
  },
  { displayKey: "CalendarHeart01", searchTerms: ["calendar", "heart", "prepaid benefits"] },
  { displayKey: "CalendarKey01", searchTerms: ["calendar", "key", "prepaid rent"] },
  { displayKey: "CalendarShield01", searchTerms: ["calendar", "shield", "prepaid insurance"] },
  {
    displayKey: "Camera01",
    searchTerms: ["camera", "photography", "video", "recording", "pictures"],
  },
  {
    displayKey: "CameraLens",
    searchTerms: ["camera", "photography", "video", "recording", "pictures"],
  },
  { displayKey: "Car01", searchTerms: ["car", "transportation", "ground", "travel", "parking"] },
  {
    displayKey: "Certificate01",
    searchTerms: ["certificate", "award", "equity", "stock", "safes", "treasury"],
  },
  { displayKey: "ClockDollar", searchTerms: ["clock", "dollar", "deferred", "time"] },
  { displayKey: "Cloud01", searchTerms: ["cloud", "hosting", "storage", "server", "computing"] },
  {
    displayKey: "CodeSnippet02",
    searchTerms: ["code", "development", "programming", "software", "engineering"],
  },
  {
    displayKey: "CoinsHand",
    searchTerms: ["coins", "hand", "accounts receivable", "revenue", "income"],
  },
  {
    displayKey: "CoinsHand02",
    searchTerms: ["coins", "hand", "accounts payable", "tax", "payroll"],
  },
  { displayKey: "CoinsHeart01", searchTerms: ["coins", "heart", "goodwill", "donation"] },
  { displayKey: "CoinsPlus01", searchTerms: ["coins", "plus", "capital", "income", "revenue"] },
  { displayKey: "CoinsStacked03", searchTerms: ["coins", "stacked", "assets", "gold", "tax"] },
  { displayKey: "Couch", searchTerms: ["couch", "fixed assets", "furniture", "chair"] },
  {
    displayKey: "CouchArrowDown",
    searchTerms: ["couch", "fixed assets", "furniture", "chair", "arrow", "down", "amortization"],
  },
  { displayKey: "CreditCard02", searchTerms: ["credit card"] },
  { displayKey: "CreditCardCheck", searchTerms: ["credit card", "check", "rewards"] },
  {
    displayKey: "CreditCardScissors",
    searchTerms: ["credit", "card", "scissors", "payment processing fees"],
  },
  { displayKey: "CurrencyDollar", searchTerms: ["currency", "dollar", "money"] },
  {
    displayKey: "Dataflow04",
    searchTerms: ["dataflow", "org", "chart", "operations", "hierarchy"],
  },
  { displayKey: "Diamond01", searchTerms: ["diamond", "raw materials", "gem"] },
  { displayKey: "DollarHand", searchTerms: ["dollar", "hand", "loans", "give", "payment"] },
  {
    displayKey: "DollarTransaction",
    searchTerms: ["dollar", "transaction", "receipt", "expenses"],
  },
  { displayKey: "EnvelopeDollar01", searchTerms: ["envelope", "dollar", "retained earnings"] },
  { displayKey: "Gift02", searchTerms: ["gift", "bonuses", "present", "promotional items"] },
  { displayKey: "Glasses02", searchTerms: ["glasses", "reading", "vision", "eye", "sight"] },
  { displayKey: "GlassFork01", searchTerms: ["glass", "fork", "meals", "food", "catering"] },
  { displayKey: "Globe02", searchTerms: ["globe", "domain", "world"] },
  {
    displayKey: "GlobeArrowDown01",
    searchTerms: ["globe", "domain", "world", "arrow", "down", "amortization"],
  },
  { displayKey: "HandShakeDollar01", searchTerms: ["handshake", "dollar", "partner", "hands"] },
  { displayKey: "Heart", searchTerms: ["heart", "love", "charity", "donation", "benefits"] },
  { displayKey: "HeartHand", searchTerms: ["heart", "hand", "benefits"] },
  { displayKey: "HeartHand02", searchTerms: ["heart", "hand", "benefits payable"] },
  { displayKey: "Home03", searchTerms: ["home", "lodging", "building", "house"] },
  { displayKey: "HomeZap", searchTerms: ["home", "zap", "utilities", "building", "house"] },
  { displayKey: "Hourglass01", searchTerms: ["hourglass", "work in progress"] },
  { displayKey: "Iou", searchTerms: ["iou", "liable", "liabilities", "owe"] },
  { displayKey: "KeyHand", searchTerms: ["key", "hand", "rent", "lease", "property"] },
  { displayKey: "Laptop03", searchTerms: ["laptop", "computer", "software", "applications"] },
  {
    displayKey: "LaptopArrowDown01",
    searchTerms: ["laptop", "computer", "arrow", "down", "amortization"],
  },
  { displayKey: "LaptopCloud01", searchTerms: ["laptop", "cloud", "applications", "software"] },
  { displayKey: "Lightbulb05", searchTerms: ["lightbulb", "idea", "intangible assets"] },
  {
    displayKey: "LightbulbArrowDown01",
    searchTerms: ["lightbulb", "arrow", "down", "idea", "intangible assets", "amortization"],
  },
  { displayKey: "LockDollar01", searchTerms: ["lock", "dollar", "security deposits", "secure"] },
  { displayKey: "Microscope", searchTerms: ["microscope", "science", "research"] },
  {
    displayKey: "MicroscopeArrowDown01",
    searchTerms: ["microscope", "science", "research", "arrow", "down", "amortization"],
  },
  { displayKey: "MoneyBag", searchTerms: ["money", "bag", "debt", "dollar"] },
  { displayKey: "MoneyBagAlert", searchTerms: ["money", "bag", "alert", "doubtful", "bad"] },
  { displayKey: "MusicNote01", searchTerms: ["music", "note", "entertainment"] },
  { displayKey: "PackageCheck", searchTerms: ["package", "check", "box", "inventory", "goods"] },
  { displayKey: "PalmTree01", searchTerms: ["palm", "tree", "vacation", "pto", "trip", "travel"] },
  { displayKey: "Paperclip", searchTerms: ["paperclip", "office supplies", "materials"] },
  {
    displayKey: "Percent02",
    searchTerms: ["percent", "interest", "dividends", "discount", "sale"],
  },
  {
    displayKey: "Phone",
    searchTerms: ["phone", "cell", "communication", "call", "contact", "telecommunications"],
  },
  { displayKey: "PieChart05", searchTerms: ["pie", "chart", "other", "income"] },
  {
    displayKey: "Plane",
    searchTerms: ["plane", "airplane", "travel", "airfare", "fly", "transportation"],
  },
  { displayKey: "Printer", searchTerms: ["printer", "printing", "documents", "paper", "ink"] },
  {
    displayKey: "QuestionTransaction",
    searchTerms: ["question", "transaction", "uncategorized", "unknown", "other"],
  },
  { displayKey: "RefreshCw04", searchTerms: ["refresh", "arrows", "subscription revenue"] },
  { displayKey: "Sale03", searchTerms: ["sale", "discount", "refunds", "percentage"] },
  { displayKey: "Scales02", searchTerms: ["scales", "legal"] },
  { displayKey: "Scissors02", searchTerms: ["scissors", "taxes", "fees", "deduction"] },
  { displayKey: "ShieldTick", searchTerms: ["shield", "tick", "insurance", "security"] },
  { displayKey: "ShoppingCart", searchTerms: ["shopping", "cart", "retail", "grocery", "store"] },
  { displayKey: "Stars01", searchTerms: ["stars", "rating", "reviews", "feedback", "ai"] },
  {
    displayKey: "Stand",
    searchTerms: ["stand", "presentation", "conference", "trade show", "meeting"],
  },
  {
    displayKey: "SwitchHorizontal01",
    searchTerms: ["switch", "horizontal", "arrows", "clearing", "reimbursements"],
  },
  {
    displayKey: "SwitchVertical01",
    searchTerms: ["switch", "vertical", "comprehensive income", "arrows"],
  },
  { displayKey: "TagDollar", searchTerms: ["tag", "dollar", "sales", "revenue", "income"] },
  { displayKey: "Tool01", searchTerms: ["tool", "wrench", "repairs", "maintenance"] },
  { displayKey: "Trademark", searchTerms: ["trademark", "patents", "copyright"] },
  {
    displayKey: "TrademarkArrowDown",
    searchTerms: ["trademark", "patents", "copyright", "arrow", "down", "amortization"],
  },
  { displayKey: "Transaction", searchTerms: ["transaction", "revenue", "income", "receipt"] },
  { displayKey: "Translate01", searchTerms: ["translate", "language", "international", "global"] },
  {
    displayKey: "TrendDown01",
    searchTerms: ["trend", "down", "depreciation", "amortization", "arrow"],
  },
  { displayKey: "TrendUp01", searchTerms: ["trend", "up", "investments", "arrow"] },
  { displayKey: "Tv04", searchTerms: ["tv", "advertising", "pr", "marketing"] },
  { displayKey: "UploadCloud01", searchTerms: ["upload", "cloud", "hosting fees", "arrow"] },
  {
    displayKey: "UserCoins01",
    searchTerms: ["user", "coins", "owner", "person", "contributions", "equity"],
  },
  {
    displayKey: "UserDollar",
    searchTerms: ["user", "dollar", "person", "payroll", "wages", "cost of labor", "salary"],
  },
  {
    displayKey: "Users02",
    searchTerms: ["users", "person", "people", "consultants", "contractors"],
  },
  { displayKey: "Wallet02", searchTerms: ["wallet", "assets"] },
  { displayKey: "Wallet05", searchTerms: ["wallet", "memberships", "dues", "purse"] },
]
